import { Container } from '@mui/material';
import styled from 'styled-components';

import authBackground from 'assets/images/authBackground.jpg';
export const AuthBackground = styled.div`
  height: 100vh;
  background-image: url(${authBackground});
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-flow: column;
`;
export const AuthContentWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  height: 85vh;
  justify-content: center;
`;
export const AuthLogoWrapper = styled.div`
  margin-top: 2rem;
  margin-left: 3rem;
  display: flex;
  flex-flow: row;
  align-content: center;
`;

export const AuthComponents = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
`;
export const AuthComponentWrapper = styled(Container)`
  width: 50%;
  display: flex;
  flex-flow: column;
  min-height: 300px;
`;
export const AuthText = styled.div`
  display: flex;
  flex-flow: column;
  width: 20rem;
  justify-content: center;
  height: 100%;
  color: white;
  h5 {
    font-size: 2rem;
    margin-bottom: 0.3rem;
    margin-top: 0.3rem;
  }
  p {
    font-size: 1.2rem;
    margin-bottom: 0.2rem;
  }
`;

export const GridWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  justify-items: center;
  width: 100%;
`;
export const AuthWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;

  width: 100%;
`;
